import { render, staticRenderFns } from "./AddSeguroiprevnumeroparcelaPage.vue?vue&type=template&id=67e40d66"
import script from "./AddSeguroiprevnumeroparcelaPage.vue?vue&type=script&lang=js"
export * from "./AddSeguroiprevnumeroparcelaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports